import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import {
    useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect
} from 'react';
import { withRouter } from 'react-router-dom';
import metadata from './WaterComponent.metadata.json5';
import styles from './WaterComponent.module.scss';

function WaterComponent(props) {
    const { wizardData: claimVM, updateWizardData, showErrors, onValidate } = props;
    const { registerComponentValidation } = useValidation('WaterComponent');
    const propertyWater = _.get(claimVM, 'lobs.homeowners.propertyWaterDamage')

    const isClaimStatus = useCallback(() => {
        return (
            ['waterdamage'].includes(_.get(claimVM.value, 'lossCause'))
        );
    }, [claimVM]);

    useEffect(() => {
        registerComponentValidation(isClaimStatus);
    }, [registerComponentValidation, isClaimStatus]);

    const getWaterSource = useCallback(
        selectedLossCause => {
            _.set(claimVM, 'lobs.homeowners.propertyWaterDamage.waterSource.value', selectedLossCause);
            updateWizardData(claimVM);
        },
        []
    );

    const overrides = {
        '@field': {
            showRequired: true
        },
        waterSource: {
            value: _.get(
                claimVM.value,
                'lobs.homeowners.propertyWaterDamage.waterSource'
            ),
            onValueChange: getWaterSource
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getWaterSource
        },
    };

    return (

        <ViewModelForm
            uiProps={metadata.pageContent}
            model={claimVM}
            overrideProps={overrides}
            onModelChange={updateWizardData}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showErrors}
        />

    );
}

WaterComponent.propTypes = wizardProps;
export default withRouter(
    withAuthenticationContext(WaterComponent)
);
